















import {
    defineComponent,
    onBeforeMount,
    onBeforeUnmount,
    onMounted,
    ref,
    watch
} from "@vue/composition-api";
import { alarm, app, sensor } from "@/store";

import useIOSDetction from "@/utilities/useIOSDetection";
import { configureMessageHub } from "../plugins/messageHub";

export default defineComponent({
    setup(_, { root }) {
        sensor.GetData();

        const loading = ref<Boolean>(true);
        const container = ref<HTMLElement>();

        onBeforeMount(() => {
            app.showFooter = false;
        });
        onBeforeUnmount(() => {
            app.showFooter = true;
        });
        onMounted(async () => {
            configureMessageHub().then(async () => {
                await alarm.GetStatus();
            });
        });
        const { showInstallMessage } = useIOSDetction();
        //if (showInstallMessage) {
        //    app.error = "bookmark";
        //}
        return {
            loading,
            container
        };
    }
});
